import {
  Action,
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from '@ngrx/store';
import {
  GUARDAR_EMAIL,
  GUARDAR_MEDIO_ENVIO,
  GUARDAR_MENSAJE,
  GUARDAR_PANTALLA,
  GUARDAR_SESION,
} from './sesion.actions';
import { SesionState } from '../app.states';
import { Sesion } from './session.interface';

export const initialState: SesionState = { sesion: {} as Sesion };

const _sesionReducer = createReducer(
  initialState,
  on(GUARDAR_SESION, (state, { sesion }) => {
    return {
      ...state,
      sesion,
    };
  }),
  on(
    GUARDAR_MEDIO_ENVIO,
    (state, { medio_envio_codigo, numero_envio_codigo }) => {
      return {
        ...state,
        sesion: {
          ...state.sesion,
          medio_envio_codigo,
          numero_envio_codigo,
        },
      };
    }
  ),

  on(GUARDAR_MENSAJE, (state, { mensaje }) => {
    return {
      ...state,
      sesion: {
        ...state.sesion,
        mensaje,
      },
    };
  }),
  on(GUARDAR_EMAIL, (state, { email }) => {
    return {
      ...state,
      sesion: {
        ...state.sesion,
        email,
      },
    };
  }),
  on(GUARDAR_PANTALLA, (state, { pantalla }) => {
    return {
      ...state,
      sesion: {
        ...state.sesion,
        pantalla,
      },
    };
  })
);

export function sesionReducer(state: SesionState | undefined, action: Action) {
  return _sesionReducer(state, action);
}

export const selectSesionState =
  createFeatureSelector<SesionState>('sesionState');

export const selectSesion = createSelector(
  selectSesionState,
  (state: SesionState) => state.sesion
);
